import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import BidService from "../../services/BidService";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function CreateBid({ open, handleClose, requirementId }) {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [expectedDeliveryDate,setExpectedDeliveryDate]=useState();

  const handleSubmit = async () => {
    debugger;

    setLoading(true);
    const payload = {
      requirementId,
      amount: Number(amount),
      note,
      expectedtoDeliver:expectedDeliveryDate
    };

    if (!amount) {
      toast.error("Amount is Required");
      setLoading(false);
      return;
    }

    try {
      const resonse = await BidService.CreateBid(payload);
      if (resonse.success) {
        handleClose();
      }
    } catch (error) {
      alert(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // return () => {
    //   // This will run on unmount
    //   console.log("Component unmounting");

    //   // Only do this if you're resetting values in a parent or store
    //   setTimeout(() => {
    //     setAmount("");
    //     setNote("");
    //   }, 0); // this is a hack, may or may not work
    // };

    if (!open) {
      setAmount("");
      setNote("");
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        minWidth: 250,
        "& .MuiDialog-paper": { minWidth: { sm: 450, xs: 350 } },
      }}
    >
      <DialogTitle>Submit Requirement</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <TextField
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          fullWidth
        />
        <TextField
          label="Note"
          multiline
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
        />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            sx={{ width: "100%" }}
            label="Expected Delivery Date"
            value={expectedDeliveryDate}
            onChange={(newValue) =>
              setExpectedDeliveryDate(newValue)
            }
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !amount}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
